export const PAGES = {
  home: "home",
  content: "content",
};
